import { render, staticRenderFns } from "./ConfigurationPouringCategories.vue?vue&type=template&id=4a1e1c4f&scoped=true&"
import script from "./ConfigurationPouringCategories.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPouringCategories.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPouringCategories.vue?vue&type=style&index=0&id=4a1e1c4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1e1c4f",
  null
  
)

export default component.exports